/**
 * DemoDataLoader.js
 * 
 * Utility to load pre-segmented demo data from S3 for the organ segmentation viewer.
 * This allows the page to display example results without requiring an EC2 instance.
 * 
 * NOTE: Demo mode only shows 3D mesh visualizations (no slice viewer)
 * 
 * Data Structure on S3:
 * - {base_url}/{DEMO_ORGAN_KEY}/mesh.json - 3D mesh data (15 organs: spleen, liver, etc.)
 */

const DEMO_DATA_BASE_URL = 'https://snorkle-segmentation-demo-data.s3.us-east-1.amazonaws.com';

// The demo organ key (multi-organ segmentation with 15 organs)
export const DEMO_ORGAN_KEY = 'hip_left_hip_right_kidney_left_kidney_right_liver_sacrum_spleen_stomach_vertebrae_L1_vertebrae_L2_vertebrae_L3_vertebrae_L4_vertebrae_L5_vertebrae_T11_vertebrae_T12';

/**
 * Load 3D mesh data from S3
 * @returns {Promise<Object>} Mesh data with 15 organs (vertices, faces, normals)
 */
export async function loadDemoMesh() {
  try {
    const response = await fetch(`${DEMO_DATA_BASE_URL}/${DEMO_ORGAN_KEY}/mesh.json`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch demo mesh: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export default {
  loadDemoMesh,
  DEMO_ORGAN_KEY
};

